import {
  ServicePropertyFilterSettings,
} from "./filter";
import {ServicePropertySortSettings} from "./ServicePropertySortSettings";
import {ServicePropertyVisualitySettings} from "./ServicePropertyVisualitySettings";

/**
 * ServicePropertySettings содержит настройки отображения свойства услуг
 */
export class ServicePropertySettings {
  /**
   * Filter содержит настройки отображения свойства в фильтре
   */
  public Filter: ServicePropertyFilterSettings = ServicePropertyFilterSettings.RestoreSettings({})

  /**
   * Sort содержит настроенные параметры сортировки по свойству
   */
  public Sort: ServicePropertySortSettings = ServicePropertySortSettings.RestoreSettings({})

  /**
   * Visuality содержит настройки отображения значения свойства
   */
  public Visuality: ServicePropertyVisualitySettings = ServicePropertyVisualitySettings.RestoreSettings({})

  /**
   * Заглушка для запрета прямого создания объектов данного типа
   * @private
   */
  private constructor() {
  }

  /**
   * RestoreSettings выполняет восстановление данных объекта настроек
   * Функция выполняет нормализацию значений настроек.
   * Функция дополняет недостающие настройки значениями по умолчанию.
   *
   * @param data
   */
  public static RestoreSettings(data: any): ServicePropertySettings {
    let result = new ServicePropertySettings();

    if (typeof data === "string") {
      data = JSON.parse(data)
    }

    if (typeof data !== "object") {
      return result;
    }

    Object.keys(result).map((key: keyof ServicePropertySettings) => {
      // @ts-ignore
      result[key] = ServicePropertySettings.GetCorrectFieldValue(key, data[key])
    })

    return result;
  }

  /**
   * GetCorrectFieldValue выполняет восстановление данных поля из переданного значения настроек.
   * Данный метод так же проводит валидацию значения каждой из настроек поля. Метод возвращает
   * значение по умолчанию, если значение передано не корректно.
   */
  public static GetCorrectFieldValue<T extends keyof ServicePropertySettings>(
    field: T,
    data: any,
  ): any {
    let defaults = new ServicePropertySettings()

    if (data === undefined) {
      return defaults[field]
    }

    switch (field) {
      case "Filter":
        return ServicePropertyFilterSettings.RestoreSettings(data)
      case "Sort":
        return ServicePropertySortSettings.RestoreSettings(data)
      case "Visuality":
        return ServicePropertyVisualitySettings.RestoreSettings(data)
    }

    return defaults[field];
  }
}